import { useContext } from "react";

import type { ColorPickerContextValue } from "./color-picker-types";

import { ColorPickerContext } from "./color-picker-context";

export const useColorPicker = (): ColorPickerContextValue => {
	const ctx = useContext(ColorPickerContext);
	if (!ctx)
		throw new Error(
			"useColorPicker must be used within <ColorPicker.Provider>",
		);
	return ctx;
};

/** Non-throwing version — returns null when outside a Provider. */
export const useColorPickerSafe = (): ColorPickerContextValue | null =>
	useContext(ColorPickerContext);
